import { cn } from "@/lib/utils";

const STYLES = [
  {
    id: "white-gradient",
    name: "Modern Clean",
    description: "Fond blanc, gradients doux",
    preview: "bg-gradient-to-br from-white to-gray-100",
    textClass: "text-gray-800",
  },
  {
    id: "red-black",
    name: "Bold Sales",
    description: "Rouge/noir, urgence",
    preview: "bg-gradient-to-br from-red-600 to-black",
    textClass: "text-white",
  },
  {
    id: "black-gold",
    name: "Luxury Gold",
    description: "Noir/or, premium",
    preview: "bg-gradient-to-br from-black to-yellow-900",
    textClass: "text-yellow-400",
  },
  {
    id: "green-nature",
    name: "Fresh Nature",
    description: "Vert naturel, éco",
    preview: "bg-gradient-to-br from-green-600 to-emerald-400",
    textClass: "text-white",
  },
  {
    id: "blue-tech",
    name: "Tech Blue",
    description: "Bleu moderne, high-tech",
    preview: "bg-gradient-to-br from-blue-600 to-cyan-400",
    textClass: "text-white",
  },
  {
    id: "warm-beige",
    name: "Warm Cozy",
    description: "Beige, lifestyle",
    preview: "bg-gradient-to-br from-orange-200 to-amber-100",
    textClass: "text-amber-900",
  },
  {
    id: "neon-gradient",
    name: "Neon Pop",
    description: "Néon vibrant, trendy",
    preview: "bg-gradient-to-br from-pink-500 via-purple-500 to-indigo-500",
    textClass: "text-white",
  },
  {
    id: "pure-white",
    name: "Minimalist",
    description: "Blanc pur, élégant",
    preview: "bg-white border border-gray-200",
    textClass: "text-gray-700",
  },
];

interface AdStylePickerProps {
  selected: string;
  onSelect: (style: string) => void;
}

export function AdStylePicker({ selected, onSelect }: AdStylePickerProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {STYLES.map((style) => (
        <button
          key={style.id}
          onClick={() => onSelect(style.id)}
          className={cn(
            "relative overflow-hidden rounded-xl border-2 transition-all duration-200",
            "hover:scale-[1.02]",
            selected === style.id
              ? "border-primary ring-2 ring-primary/20"
              : "border-transparent"
          )}
        >
          <div className={cn("aspect-[4/3] p-3 flex flex-col justify-end", style.preview)}>
            <div className={cn("text-left", style.textClass)}>
              <p className="font-bold text-sm">{style.name}</p>
              <p className="text-xs opacity-80">{style.description}</p>
            </div>
          </div>
          {selected === style.id && (
            <div className="absolute top-2 right-2 w-4 h-4 rounded-full bg-primary" />
          )}
        </button>
      ))}
    </div>
  );
}
